export function initSticky(){

  const stickies = document.querySelectorAll('.sticky');
  if(!stickies.length) return;

  const header = document.querySelector('header');
  const offset = 30;

  function updateSticky(){

    const headerHeight = header ? header.offsetHeight : 0;
    const scrollY = window.scrollY;

    stickies.forEach(sticky => {

      const section = sticky.closest('section');
      const parent  = sticky.parentElement;

      if(!section || !parent) return;

      const sectionTop    = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      const stickyHeight  = sticky.offsetHeight;

      const parentRect = parent.getBoundingClientRect();
      const parentTop  = parent.offsetTop;

      const start = sectionTop + parentTop - headerHeight;
      const end   = sectionTop + sectionHeight - stickyHeight - headerHeight - offset*2;

      // estado normal
      if(scrollY < start){

        sticky.style.position = '';
        sticky.style.top = '';
        sticky.style.width = '';
        sticky.style.left = '';

      }

      // estado sticky
      else{

        const width = parent.offsetWidth;
        const left  = parentRect.left;

        sticky.style.position = 'fixed';
        sticky.style.top = (headerHeight + offset) + 'px';
        sticky.style.width = width + 'px';
        sticky.style.left = left + 'px';

        // limitar al final de la sección
        if(scrollY > end){

          const diff = scrollY - end;
          sticky.style.top = (headerHeight + offset - diff) + 'px';

        }

      }

    });

  }

  window.addEventListener('scroll', updateSticky);
  window.addEventListener('resize', updateSticky);

  updateSticky();

}